"use strict";

exports.presendPaymentAbi = void 0;
const presendPaymentAbi = exports.presendPaymentAbi = ['function payPreSendFee(address currency, uint256 amount, uint256 currencyPrice) external payable', 'function payPreSendFee(address currency, uint256 amount, uint256 currencyPrice, address affiliate, uint256 affiliatePercentage) external payable'];